import React, { useState } from 'react';
import { useAuth } from '../Auth/AuthProvider';
import { Terminal, LogOut, User, Trophy, Settings, Menu, X, Users, CreditCard } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

export const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <Link to="/" className="flex items-center space-x-3">
            <Terminal className="w-8 h-8 text-blue-400" />
            <h1 className="text-2xl font-bold text-gradient">
              OpsQuest
            </h1>
            <span className="text-xs bg-green-500/20 text-green-400 px-2 py-1 rounded-full">
              BETA
            </span>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <div className="flex items-center space-x-4">
                  <Link to="/dashboard" className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors">
                    <Trophy className="w-4 h-4" />
                    <span>Dashboard</span>
                  </Link>
                  <Link to="/community" className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors">
                    <Users className="w-4 h-4" />
                    <span>Community</span>
                  </Link>
                  <Link to="/billing" className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors">
                    <CreditCard className="w-4 h-4" />
                    <span>Billing</span>
                  </Link>
                  <button className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors">
                    <Settings className="w-4 h-4" />
                    <span>Settings</span>
                  </button>
                </div>
                
                <div className="flex items-center space-x-3 bg-gray-800/50 rounded-lg px-3 py-2">
                  <User className="w-4 h-4 text-gray-400" />
                  <span className="text-white font-medium">{user.username}</span>
                </div>
                
                <button
                  onClick={handleLogout}
                  className="btn-danger flex items-center space-x-2"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <span className="text-gray-300">Please log in</span>
            )}
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-300 hover:text-white"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-800 py-4">
            {user ? (
              <div className="space-y-4">
                <div className="flex items-center space-x-3 px-3 py-2 bg-gray-800/50 rounded-lg">
                  <User className="w-4 h-4 text-gray-400" />
                  <span className="text-white font-medium">{user.username}</span>
                </div>
                
                <div className="space-y-2">
                  <Link to="/dashboard" className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors w-full text-left p-2">
                    <Trophy className="w-4 h-4" />
                    <span>Dashboard</span>
                  </Link>
                  <Link to="/community" className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors w-full text-left p-2">
                    <Users className="w-4 h-4" />
                    <span>Community</span>
                  </Link>
                  <Link to="/billing" className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors w-full text-left p-2">
                    <CreditCard className="w-4 h-4" />
                    <span>Billing</span>
                  </Link>
                  <button className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors w-full text-left p-2">
                    <Settings className="w-4 h-4" />
                    <span>Settings</span>
                  </button>
                </div>
                
                <button
                  onClick={handleLogout}
                  className="btn-danger w-full flex items-center justify-center space-x-2"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Logout</span>
                </button>
              </div>
            ) : (
              <div className="text-center text-gray-300">Please log in</div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};
